module.exports = "<div class=postcard-field ng-hide=hideMap> <h2 class=form-label translate>post.location</h2> <div id=post-map class=map></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/detail/map.html
// module id = 698
// module chunks = 0